// removed by extract-text-webpack-plugin
module.exports = {"page":"_3xpjZmjpS _2l0xl0HVf m_MD8dOe5 yJ3aJSEV8 kthKJ-hIO _2D5O9dQtF M02IhxSCi _-1CuDyzo1","title":"_1pQcqxEAd _1yJuXbiru _20rWKo4VQ _1yThnDgzj _1BE2U7F8v _3kvYUMIJc _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j _1C-lRJLgc _1zU9pZnM6 _2ZDRZa8To _1JAgybqD3"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/event-group-integrations-page/event-group-integrations-page.css
 ** module id = 2189
 ** module chunks = 0
 **/